import { calcTotalEnergy, calcTotalSave, getRecommand } from '@/constants/cost-saving';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from 'elem/compCommon/EFPicture';
import { cloneDeep } from 'lodash';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import useCardsShowHook from '../useHooks/useCardsShowHook';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';
import { Tooltip } from 'antd';

const SECTION_E_DATA_MAP: any = {
    us: {
        solarPanels: [
            {
                img: '/responsive/picture/common-products/400w_rigid.png',
                quantity: 1,
                isActive: true,
                energy: 400,
                id: '400w_rigid',
                titleKey: 'secE_card_400w_rigid',
                cartTitleKey: 'secE_cart_400w_rigid_name',
                productId: '6841245925449',
                variantId: '40250363478089',
            },
            {
                img: '/responsive/picture/common-products/400w.png',
                quantity: 4,
                isActive: true,
                energy: 400,
                id: '400w',
                title: '400W',
                cartTitle: 'EcoFlow 400W Portable Solar Pabel',
                productId: '6618094960713',
                variantId: '39998021697609',
            },
            {
                img: '/responsive/picture/common-products/400w.png',
                quantity: 1,
                isActive: false,
                energy: 500,
                id: '500w',
                title: '500W',
                cartTitle: 'EcoFlow 500W Portable Solar Pabel',
                productId: '15030544531827',
                variantId: '52317425009011',
            },
        ],
        cards: [
            {
                img: '',
                tagKey: 'common_card_tag',
                powerKey: 'secE_card3_power',
                titleKey: 'secE_card3_title',
                id: 'dpux',
                link_more: 'https://us.ecoflow.com/products/delta-pro-ultra-x?_pos=1&_sid=4f824b9b6&_ss=r&variant=54714781204553',
                productId: '15391292588105',
                variantId: '54714781204553',
                descKeys: ['secE_card3_desc1', 'secE_card3_desc2', 'secE_card3_desc3'],
                childIds: ['400w'],
            },
            {
                img: '',
                tagKey: 'common_card_tag',
                powerKey: 'secE_card1_power',
                titleKey: 'secE_card1_title',
                id: 'dpu',
                link_more: 'https://us.ecoflow.com/products/smart-home-panel-2?variant=40767883608137',
                productId: '6964802486345',
                variantId: '40767883608137',
                descKeys: ['secE_card1_desc1', 'secE_card1_desc2', 'secE_card1_desc3'],
                childIds: ['400w'],
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1769583906390/Frame%202094655033.png',
                tagKey: 'common_card_tag',
                powerKey: 'secE_card2_power',
                titleKey: 'secE_card2_title',
                id: 'dp3',
                link_more: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41703627980873',
                productId: '7185477075017',
                variantId: '41703627980873',
                descKeys: ['secE_card2_desc1', 'secE_card2_desc2', 'secE_card2_desc3'],
                childIds: ['400w'],
            },
        ],
    },
    ca: {
        solarPanels: [
            {
                id: '400w_rigid',
                productId: '8006700236954',
                variantId: '44244774682778',
            },
            {
                id: '400w',
                productId: '7287920001178',
                variantId: '42092770263194',
            },
            {
                id: '500w',
                productId: '15030544531827',
                variantId: '52317425009011',
            },
        ],
        cards: [
            {
                productId: '8006700236954',
                variantId: '44244774682778',
            },
        ],
    },
};

export default function E() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('costsaving-new');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [focus, setFocus] = useState('');
    const [flag, setFlag] = useState(false);
    const [flag2, setFlag2] = useState(false);
    const [flag3, setFlag3] = useState(false);
    const [opens, setOpens] = useState([]);
    const [openTooltipKey, setOpenTooltipKey] = useState(null);
    const isNA = ['us', 'ca'].includes(locale);

    useEffect(() => {
        if (!openTooltipKey || typeof window === 'undefined') return;

        const closeTooltip = (e?: any) => {
            // 点击的是加号按钮本身时，交给 antd 的受控切换处理，避免出现“先关再开”导致需要点两次
            const target = e?.target;
            if (target && typeof target.closest === 'function' && target.closest('.addSubtractor-add')) {
                return;
            }
            setOpenTooltipKey(null);
        };

        document.addEventListener('mousedown', closeTooltip, true);
        document.addEventListener('touchstart', closeTooltip, true);
        document.addEventListener('pointerdown', closeTooltip, true);
        window.addEventListener('scroll', closeTooltip, true);
        window.addEventListener('wheel', closeTooltip, true);
        window.addEventListener('touchmove', closeTooltip, true);

        return () => {
            document.removeEventListener('mousedown', closeTooltip, true);
            document.removeEventListener('touchstart', closeTooltip, true);
            document.removeEventListener('pointerdown', closeTooltip, true);
            window.removeEventListener('scroll', closeTooltip, true);
            window.removeEventListener('wheel', closeTooltip, true);
            window.removeEventListener('touchmove', closeTooltip, true);
        };
    }, [openTooltipKey]);

    const getLocalSectionEData = () => {
        const usData = SECTION_E_DATA_MAP.us;
        const localData = SECTION_E_DATA_MAP[locale] || {};
        const localSolarPanelMap = (localData.solarPanels || []).reduce((map: any, item: any) => {
            map[item.id] = item;
            return map;
        }, {});
        const baseSolarPanelIds = usData.solarPanels.map((item: any) => item.id);
        const extraSolarPanels = (localData.solarPanels || []).filter((item: any) => !baseSolarPanelIds.includes(item.id));
        const solarPanelConfigs = [...usData.solarPanels.map((item: any) => ({ ...item, ...(localSolarPanelMap[item.id] || {}) })), ...extraSolarPanels];

        const getText = (key?: string) => (key ? t(key) : '');
        const solarPanels = solarPanelConfigs.map(({ titleKey, cartTitleKey, ...item }: any) => ({
            ...item,
            title: titleKey ? getText(titleKey) : item.title,
            cartTitle: cartTitleKey ? getText(cartTitleKey) : item.cartTitle,
        }));
        const cardConfigs = localData.cards || usData.cards;
        const cards = cardConfigs.map(({ tagKey, powerKey, titleKey, descKeys, childIds, ...item }: any) => ({
            ...item,
            tag: getText(tagKey),
            power: getText(powerKey),
            title: getText(titleKey),
            descArr: descKeys.map((key: string) => getText(key)),
            children: cloneDeep(solarPanels.filter((solarPanel: any) => childIds.includes(solarPanel.id))),
        }));

        return { solarPanels, cards };
    };

    const localSectionEData = getLocalSectionEData();
    const [solarpanels, setSolarpanels] = useState(localSectionEData.solarPanels);
    const [cardLists, setCardLists] = useState(localSectionEData.cards);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: card.title,
                position: `Cost Saving Page_${card?.title}`,
            });
            // fb埋点
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            // window.open(card?.link_buy, '_blank');
            const target = card?.children?.find((item: any) => item.isActive);
            const addCarts: ItfEcoCartItem[] = [
                {
                    compareAtPrice: card?.compareAtPrice,
                    price: card?.price,
                    inventoryQuantity: card?.inventoryQuantity,
                    inventoryPolicy: card?.inventoryPolicy,
                    productId: card?.productId,
                    variantId: card?.variantId,
                    img: card?.img,
                    variantImg: card?.variantImg,
                    productTitle: card?.productTitle,
                    skuTitle: card?.skuTitle,
                    quantity: 1,
                },
            ];
            if (target?.quantity > 0) {
                addCarts.push({
                    compareAtPrice: target?.compareAtPrice,
                    price: target?.price,
                    inventoryQuantity: target?.inventoryQuantity,
                    inventoryPolicy: target?.inventoryPolicy,
                    productId: target?.productId,
                    variantId: target?.variantId,
                    img: target?.img,
                    variantImg: target?.variantImg,
                    productTitle: target?.productTitle,
                    skuTitle: target?.skuTitle,
                    quantity: target?.quantity,
                });
            }
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, addCarts);
        }
    };

    const handleClick = (card: any, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        const activeIdx = tempChildren.findIndex((item: any) => item.isActive);
        tempChildren[activeIdx].isActive = false;
        tempChildren[m].isActive = true;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCount = (data: any, num: number, k: number, m: number) => {
        // setFocus(`${data?.variantId}_${k}_${m}`);
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        tempChildren[m].quantity = num;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCalclate = (card: any, list: any) => {
        card.energy = calcTotalEnergy(list?.energy, list?.quantity);
        card.saveMoney = calcTotalSave(list?.energy, list?.quantity);
    };

    const setSolarStatu = (item: any, child?: any) => {
        if (!child) {
            child = item?.children?.find((list: any) => list?.isActive);
        }
        // 推荐状态：0 数量0-置灰 1：推荐 2:不推荐
        item.statu = child?.quantity === 0 ? 0 : child?.recommand?.includes(child?.quantity) ? 1 : 2;
    };

    const AddSubtractor = ({ data, callback, k, m }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = data?.inventoryQuantity ?? 99;
        const { useState, useEffect } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 1);
        const isButtonsDisabled = Number(data?.inventoryQuantity || 0) <= 0 && data?.inventoryPolicy !== 'continue';
        const isPlusDisabled = number >= NUM_MAX || isButtonsDisabled;
        const tooltipKey = `${k}_${m}_${data?.variantId || data?.id || data?.title || ''}`;

        useEffect(() => {
            setNumber(data?.quantity ?? 1);
        }, [data?.quantity]);

        const reduceNumber = () => {
            if (isButtonsDisabled || number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1, k, m);
        };

        const addNumber = () => {
            if (isButtonsDisabled || number >= NUM_MAX) return false;
            setOpenTooltipKey(null);
            setNumber(number + 1);
            callback(data, number + 1, k, m);
        };

        const inputChange = (e: any) => {
            if (isButtonsDisabled) return;
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX || !Boolean(Number(v))) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v), k, m);
        };

        return (
            <div className="addSubtractor">
                <div className={`addSubtractor-reduce${number <= NUM_MIN || isButtonsDisabled ? ' disable' : ''}`} onClick={reduceNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        {/* <g opacity="0.4"> */}
                        <path
                            d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM7.75781 11.2002C7.3436 11.2002 7.00781 11.536 7.00781 11.9502C7.00805 12.3642 7.34375 12.6992 7.75781 12.6992H16.2422C16.6563 12.6992 16.9919 12.3642 16.9922 11.9502C16.9922 11.536 16.6564 11.2002 16.2422 11.2002H7.75781Z"
                            fill="#18191B"
                        />
                        {/* </g> */}
                    </svg>
                </div>
                <input className="addSubtractor-number" autoFocus={focus === `${data?.variantId}_${k}_${m}`} value={number} onChange={inputChange} />
                {isPlusDisabled ? (
                    <Tooltip
                        title={t('item_maximum_purchase_quantity')}
                        trigger="click"
                        visible={openTooltipKey === tooltipKey}
                        onVisibleChange={(visible) => {
                            setOpenTooltipKey((currentKey: any) => (visible ? tooltipKey : currentKey === tooltipKey ? null : currentKey));
                        }}
                    >
                        <div className="addSubtractor-add disable">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                    fill="black"
                                />
                                <path
                                    d="M12.0117 6.85938C12.4257 6.85963 12.7607 7.19532 12.7607 7.60938V11.2012H16.3408C16.7547 11.2014 17.0897 11.5372 17.0898 11.9512C17.0898 12.3652 16.7548 12.7009 16.3408 12.7012H12.7607V16.2939C12.7605 16.7078 12.4256 17.0427 12.0117 17.043C11.5976 17.043 11.2619 16.708 11.2617 16.2939V12.7012H7.65625C7.24204 12.7012 6.90625 12.3654 6.90625 11.9512C6.9064 11.5371 7.24213 11.2012 7.65625 11.2012H11.2617V7.60938C11.2617 7.19516 11.5975 6.85938 12.0117 6.85938Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </Tooltip>
                ) : (
                    <div className="addSubtractor-add" onClick={addNumber}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
                                fill="black"
                            />
                            <path
                                d="M12.0117 6.85938C12.4257 6.85963 12.7607 7.19532 12.7607 7.60938V11.2012H16.3408C16.7547 11.2014 17.0897 11.5372 17.0898 11.9512C17.0898 12.3652 16.7548 12.7009 16.3408 12.7012H12.7607V16.2939C12.7605 16.7078 12.4256 17.0427 12.0117 17.043C11.5976 17.043 11.2619 16.708 11.2617 16.2939V12.7012H7.65625C7.24204 12.7012 6.90625 12.3654 6.90625 11.9512C6.9064 11.5371 7.24213 11.2012 7.65625 11.2012H11.2617V7.60938C11.2617 7.19516 11.5975 6.85938 12.0117 6.85938Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                )}
            </div>
        );
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    const getAsynItem = async (item: any) => {
        const { productId, variantId, link_more } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    if (res.data && typeof res.data === 'object' && Object.keys(res.data).length === 0) {
                        return resolve({});
                    }
                    if (link_more) {
                        handleCalclate(item, item.children[0]);
                    }
                    res.data.link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                    if (res?.data?.handle) {
                        res.data.link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                    }
                    return resolve({ ...item, ...res?.data });
                } else {
                    console.error(res?.message);
                    return reject([{ ...item }]);
                }
            } catch (e) {
                console.error(e);
                return reject([{ ...item }]);
            }
        });
    };

    useEffect(() => {
        if (isNA && flag) {
            const tempSolarPanelsArr = JSON.parse(JSON.stringify(solarpanels));
            const solarPromises = tempSolarPanelsArr?.map((item: any) => getAsynItem(item));
            Promise.all(solarPromises)
                .then((res: any) => {
                    setSolarpanels(res.filter((item: any) => Object.keys(item || {}).length > 0));
                    setFlag2(true);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, [flag]);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const promises = tempArr?.map((item: any) => getAsynItem(item));
        Promise.all(promises)
            .then((res: any) => {
                setCardLists(res.filter((item: any) => Object.keys(item || {}).length > 0));
                setFlag(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        if (isNA && flag && flag2) {
            const tempArr = JSON.parse(JSON.stringify(cardLists));
            console.log('res-E-cardLists::', cardLists, solarpanels);
            tempArr?.map((item: any, k: number) => {
                // item.children = JSON.parse(JSON.stringify());
                const children = cloneDeep(item.children.map((_item: any) => solarpanels.find((s: any) => s.id === _item.id)).filter((item: any) => !!item));
                item.children = children;
                item?.children?.map((child: any) => {
                    child.parentVariantId = item?.variantId;
                    child.recommand = getRecommand(item?.id, String(child?.id));
                    if (Number(child?.inventoryQuantity || 0) <= 0 && child?.inventoryPolicy !== 'continue') {
                        child.quantity = 0;
                    } else if (child?.recommand?.length > 0 && child?.inventoryQuantity < child?.recommand[0]) {
                        child.quantity = child?.inventoryQuantity;
                    } else {
                        child.quantity = child?.recommand?.length > 0 ? child?.recommand[0] : 0;
                    }
                    // child.quantity = child.recommand[0];
                });
                setSolarStatu(item, item?.children[0]);
                handleCalclate(item, item?.children[0]);
            });
            setCardLists(tempArr);
            setFlag3(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [solarpanels, flag, flag2]);

    useCardsShowHook('.cost-saving-E .swiper-box .swiper-item', '.cost-saving-E');
    return (
        <div
            id="cost-saving-E"
            className={`cost-saving-E  ${css['cost-saving-E']} GtmModuleData-section`}
            data-section-id={'cost-saving-E'}
            data-section-title={t('secE_title')}
        >
            <Swiper
                className="cards swiper-box"
                effect="fade"
                modules={[Scrollbar]}
                spaceBetween={gap}
                // centeredSlides={gap !== 16}
                slidesPerView={'auto'}
                initialSlide={0}
                centerInsufficientSlides={true}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cardLists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        {card?.tag && <span className="card-tag">{card?.tag}</span>}
                        <div className="card-top">
                            <div className="card-img">
                                <EFPicture src={card?.variantImg || card?.img} alt={card?.title} />
                            </div>
                            <p className="card-power">{card?.power}</p>
                            <p className="card-title">{card?.title || card?.productTitle || card?.skuTitle}</p>
                            <ul className="card-descs">
                                {card?.descArr?.map(
                                    (desc: any, m: number) =>
                                        desc && (
                                            <li className="card-desc li" key={`${k}_${m}`}>
                                                {desc}
                                            </li>
                                        ),
                                )}
                            </ul>
                            {card?.children?.length > 0 && (
                                <>
                                    <div className={`calc-info`}>
                                        <p className={`card-calc`}>{t('common_card_calculator')}</p>
                                        <p className={`card-calc-res ${card?.statu === 0 ? 'gray' : card?.statu === 1 ? 'recommand' : 'not-recommand'}`}>
                                            {card?.statu === 0
                                                ? t('common_card_0')
                                                : card?.statu === 1
                                                ? t.rich('common_card_calculator_res', {
                                                      power: card?.energy,
                                                      money: card?.saveMoney,
                                                      h: (text: string) => (
                                                          <span className="h">
                                                              {t('common_card_unit')}
                                                              {text}
                                                          </span>
                                                      ),
                                                  })
                                                : t('common_card_no_recommand')}
                                        </p>
                                    </div>

                                    <div className="card-output">
                                        <p className="output-text">{t('secE_card_output')}</p>
                                        <ul className="output-lists">
                                            {card?.children?.map((list: any, m: number) => (
                                                <li
                                                    className={`output-list ${list?.isActive ? 'active' : ''}`}
                                                    key={`${k}_${m}`}
                                                    onClick={() => handleClick(card, k, m)}
                                                >
                                                    {list?.title}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="card-quantity card-output">
                                        {/* <p className="output-text">{t('secE_card_quantity')}</p> */}
                                        <ul className="quantity-lists">
                                            {card?.children?.map((list: any, m: number) => (
                                                <li className={`quantity-list ${list?.isActive ? 'show' : 'hide'}`} key={`${k}_${m}`}>
                                                    <AddSubtractor data={list} callback={handleCount} k={k} m={m} />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            )}

                            {card?.text?.desc && (
                                <div className="card-text-box">
                                    <p className="text-title">{card?.text?.title}</p>
                                    <div className={`text-desc-box ${opens?.includes(k) ? 'open' : 'close'}`}>
                                        <p className="text-desc">
                                            {t.rich(card?.text?.desc, {
                                                c: (tx: string) => <span className="c">{tx}</span>,
                                            })}
                                        </p>
                                        <span
                                            className="arrow"
                                            onClick={() => setOpens(opens?.includes(k) ? opens?.filter((o: number) => o !== k) : [...opens, k])}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                <path
                                                    d="M2.42822 7.82052L6.33468 3.91406L10.2411 7.82052"
                                                    stroke="white"
                                                    strokeWidth="1.02544"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="card-bot">
                            <div className="card-btns">
                                <>
                                    {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'continue' ? (
                                        <button disabled className={`btn-buy card-btn disable`}>
                                            {t('common_card_out')}
                                        </button>
                                    ) : (
                                        <p
                                            className={`btn-buy card-btn`}
                                            onClick={() => {
                                                gtm.push({
                                                    __btn_id1: `item-${k + 1} .btn-buy .card-btn`,
                                                    __btn_id2: t('common_card_buy'),
                                                    __btn_type: 'text',
                                                });
                                                flag && flag2 && flag3 && handleBuy(card);
                                            }}
                                        >
                                            {t('common_card_buy')}
                                        </p>
                                    )}
                                </>
                                {card?.link_more && (
                                    <Link
                                        className="btn-more card-btn"
                                        href={`${card?.link_more}${
                                            String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                        }utm_source=scenario+page&utm_medium=Pillar`}
                                        target="_blank"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'select_product',
                                            list_name: t('secE_title'),
                                            product_name: card.title,
                                            button_name: t('common_card_more'),
                                            __btn_id1: `item-${k + 1} .btn-more .card-btn`,
                                            __btn_id2: `${card?.link_more}${
                                                String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                            }utm_source=scenario+page&utm_medium=Pillar`,
                                            __btn_type: 'href',
                                        }}
                                    >
                                        {t('common_card_more')}
                                    </Link>
                                )}
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
